import { optionTitle_shareACalendar } from './SharedCalendarsOption.locstring.json';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { createLazyOption, LazyOption } from 'owa-options-core';

var lazyFullModule = new LazyModule(() => import('./lazyFullSharedCalendarsOption'));
const SharedCalendarsOption: LazyOption = createLazyOption(
    {
        key: 'sharedCalendars',
        titleStringKey: optionTitle_shareACalendar,
        searchTermsStringKey: optionTitle_shareACalendar,
        isHidden: () => IsShadowMailboxUser(),
        allowedOptionKeys: ['CalendarPublishing'],
    },
    lazyFullModule,
    m => m.default
);
export default SharedCalendarsOption;
